module.exports = __webpack_public_path__ + "img/avantage-concurrentiel.a5a18133.jpg";